// extracted by mini-css-extract-plugin
module.exports = {"container":"CertificateSection_container__lNxpx","imageContainer":"CertificateSection_imageContainer__AiVSU"};